export const FileTypeFilterEnum = {
  PDF: 'pdf',
  WORD: 'doc/docx',
  EXCEL: 'xls/xlsx',
  POWERPOINT: 'ppt/pptx',
  TEXT: 'txt',
  IMAGE: 'image',
  VIDEO: 'video',
  AUDIO: 'audio',
  ZIP: 'zip/rar',
  CSV: 'csv',
  JSON: 'json',
  XML: 'xml'
};

export const FileTypeFilterValues = Object.values(FileTypeFilterEnum); 